import {mapGetters} from "vuex";
import {commonValidateRule} from './utils'
import { contract_broad_types, balance_types } from '@/libs/conctract_utils.js'
import { VChip } from 'vuetify/lib'
export default {
    computed: {
        ...mapGetters({
            teams: 'async/root_teams',
        }),
        fields() {
            return [
                {
                    label: '收支类型',
                    key: 'balance_type',
                    type: 'select_field_v1',
                    'item-text': 'title',
                    'item-value': 'key',
                    items: balance_types.list,
                    rules: [commonValidateRule('收支类型必选')]
                },
                {
                    label: '合同大类',
                    key: 'main_type',
                    type: 'select_field_v1',
                    'item-text': 'title',
                    'item-value': 'key',
                    rules: [commonValidateRule('合同大类必选')],
                    items: contract_broad_types.list
                },
                {
                    label: '合同小类',
                    key: 'sub_type',
                    rules: [commonValidateRule('合同小类必填')],
                },
                {
                    label: '关联存货/课程',
                    key: 'relation_type',
                    type: 'select_field_v1',
                    'item-text': 'title',
                    'item-value': 'key',
                    rules: [commonValidateRule('关联存货/课程必选')],
                    items: [
                        {
                            title: '存货',
                            key: 'stock'
                        },
                        {
                            title: '课程',
                            key: 'course'
                        },
                        {
                            title: '存货和课程',
                            key: 'stock_course'
                        },
                        {
                            title: '无',
                            key: 'none'
                        }
                    ]
                },
                {
                    label: '所属团队',
                    key:'teams',
                    type: 'autocompletes',
                    required: true,
                    items: this.teams.filter(item => !item.del),
                    'item-value':'id',
                    'item-text':'name', // 'name',
                    multiple: true,
                    rules: [(val) => {
                        return val && !!val.length || '所属团队必选'
                    }],
                    scopedSlots: {
                        selection: (data) => {
                            return <VChip
                                class = {data.attrs.class}
                                input-value={data.selected}
                                close
                                on={{
                                    click: (e) => {
                                        e.stopPropagation()
                                    },
                                    'click:close': () => {
                                        const id = data.item.id
                                        const index = this.params.teams.indexOf(id)
                                        this.params.teams.splice(index, 1)
                                    }
                                }}
                            >
                                {data.item.name}
                                </VChip>
                        }
                    }
                },
                {
                    label: '分析组审核',
                    key:'need_at_audit',
                    type: 'checkbox',
                },
                {
                    label: '需要提交账单',
                    key:'self_submit_bill',
                    type: 'checkbox',
                }
            ]
        }
    }
}